(function () {
  'use strict';
  /*
    Metal can Brown offerte dès 150 € — DarePouch.

    Shopify rend la can gratuite : remise automatique « FREE METAL CAN », −100 % sur la
    seule variante Brown, sans minimum (une remise native ne sait pas mesurer « panier ≥ 150 € »
    quand les paliers volume tournent). Le seuil, c'est ce script qui le tient, sur l'ÉTAT du
    panier (/cart.js), à chaque écriture panier :

      - panier hors can ≥ 150 € (après paliers, avant code promo) → une can, et une seule ;
      - en dessous → la can sort du panier ;
      - un code promo appliqué → la can sort aussi : elle ne se cumule pas avec un code ;
      - si Shopify ne la met pas à 0 € (remise coupée, conflit avec une autre remise)
        → elle sort aussi : on n'encaisse jamais 29,90 € pour un cadeau ;
      - un client qui la retire lui-même n'est pas resservi pendant sa visite ;
      - can épuisée (ajout refusé) → on ne réessaie qu'une demi-heure plus tard.

    ÉCRITURES — par le fetch d'un iframe vide de la même origine, comme dp-gift-codes.js.
    Moon Bundles enveloppe window.fetch : il OUVRE son tiroir sur tout ajout au panier réussi
    et le FERME sur tout ajout refusé. Passé par window.fetch, l'ajout de la can épuisée
    refermait le tiroir sous les yeux du client, à chaque article ajouté au-delà de 150 €.

    RÉVEIL — aucune lecture en boucle : PerformanceObserver sur les requêtes panier terminées
    (bas de fichier).
  */

  var VARIANT = 45551578382515;          // OutDare - Metal Can Brown (SKU 2198)
  var THRESHOLD = 15000;                 // 150,00 €, en centimes
  var DISCOUNT_TITLE = /FREE METAL CAN/i;
  var KEY_DECLINED = 'dpGiftDeclined';   // le client l'a retirée : on ne la remet pas
  var KEY_REFUSED = 'dpGiftRefused';     // Shopify ne l'a pas offerte à ce montant
  var KEY_SOLDOUT = 'dpGiftSoldOut';     // heure du dernier ajout refusé (épuisée)
  var SOLDOUT_WAIT = 30 * 60 * 1000;

  var CART = { items: [] };
  var busy = false;
  var hadGift = false;    // la can était au panier, offerte, au dernier état connu

  var ROOT = (function () {
    var m = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    return m.replace(/\/$/, '');
  })();
  function cartUrl(p) { return location.origin + ROOT + '/cart' + p; }

  function store(k, v) {
    try { if (v === null) sessionStorage.removeItem(k); else sessionStorage.setItem(k, String(v)); } catch (e) {}
  }
  function read(k) { try { return sessionStorage.getItem(k); } catch (e) { return null; } }
  function soldOut() { return Date.now() - (parseInt(read(KEY_SOLDOUT), 10) || 0) < SOLDOUT_WAIT; }

  // ── le vrai fetch, hors des enveloppes du thème et des apps ─────────────
  var NATIVE = null;
  function nativeFetch() {
    if (NATIVE) return NATIVE;
    try {
      var f = document.createElement('iframe');
      f.style.display = 'none';
      f.setAttribute('aria-hidden', 'true');
      f.tabIndex = -1;
      document.body.appendChild(f);
      if (f.contentWindow && f.contentWindow.fetch) NATIVE = f.contentWindow.fetch.bind(f.contentWindow);
    } catch (e) {}
    return NATIVE || window.fetch.bind(window);
  }

  function getCart() {
    return fetch(cartUrl('.js'), { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) { CART = c; return c; });
  }

  // Les autres scripts du thème ne voient pas cette écriture (fetch de l'iframe) : on les prévient.
  function post(path, body) {
    return nativeFetch()(cartUrl(path), {
      method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) {
      if (r.ok) document.dispatchEvent(new CustomEvent('dp:cart-changed'));
      return r.json().then(function (j) { return { ok: r.ok, body: j }; }, function () { return { ok: r.ok }; });
    });
  }

  function isGift(it) { return it.variant_id === VARIANT; }

  // Le panier qui compte : tout sauf la can, prix après paliers volume (remises de ligne),
  // avant les codes de réduction (remises de panier).
  function base(cart) {
    return (cart.items || []).reduce(function (s, it) {
      return isGift(it) ? s : s + (it.final_line_price || 0);
    }, 0);
  }

  // Un code promo appliqué au panier (champ « Code promo » du tiroir, lien /discount/…) : la can ne
  // se cumule pas. Un code tapé au paiement échappe au script, et la remise FREE METAL CAN doit
  // rester cumulable : sinon Shopify garde le code et facture la can 29,90 € (testé le 11/10/2026).
  function hasCode(cart) {
    return (cart.discount_codes || []).some(function (d) { return d.applicable; });
  }

  function settle(cart) {
    if (busy) return Promise.resolve(null);
    if (cart.currency && cart.currency !== 'EUR') return Promise.resolve(null);
    var gifts = (cart.items || []).filter(isGift);
    var b = base(cart);
    var eligible = b >= THRESHOLD && !hasCode(cart);
    var updates = {}, change = false;

    // Retirée à la main alors qu'elle était due : le client n'en veut pas.
    if (eligible && hadGift && !gifts.length && !read(KEY_DECLINED)) store(KEY_DECLINED, 1);
    hadGift = false;

    if (!eligible) {
      gifts.forEach(function (it) { updates[it.key] = 0; change = true; });
    } else {
      gifts.forEach(function (it, i) {
        var want = i === 0 ? 1 : 0;
        if (it.quantity !== want) { updates[it.key] = want; change = true; }
      });
      // Shopify ne l'offre pas : on la retire et on ne la repropose qu'à un autre montant.
      if (gifts.length && gifts[0].final_line_price > 0 && !change) {
        updates[gifts[0].key] = 0; change = true;
        store(KEY_REFUSED, b);
      }
    }

    busy = true;
    var step;
    if (change) {
      step = post('/update.js', { updates: updates }).then(function (r) { return r.body; });
    } else if (eligible && !gifts.length && !read(KEY_DECLINED) && read(KEY_REFUSED) !== String(b) && !soldOut()) {
      step = post('/add.js', { items: [{ id: VARIANT, quantity: 1, properties: { _gift: 'metal-can-150' } }] })
        .then(function (r) {
          if (!r.ok) { store(KEY_SOLDOUT, Date.now()); return null; }   // panier inchangé
          return getCart();
        });
    } else {
      step = Promise.resolve(null);
    }
    return step.then(function (c) {
      busy = false;
      if (c && c.items) { CART = c; redraw(); }
      var g = (CART.items || []).filter(isGift)[0];
      if (g && g.final_line_price > 0 && base(CART) >= THRESHOLD && read(KEY_REFUSED) !== String(base(CART))) {
        return settle(CART);                  // ajoutée mais pas offerte : un tour pour la retirer
      }
      hadGift = !!(g && g.final_line_price === 0);
      relabel();
      return c;
    }, function () { busy = false; });
  }

  // Le tiroir Moon Bundles ne voit pas nos écritures : on lui passe le panier à jour.
  // Son propre rechargement, lancé avant notre écriture, peut finir après et remettre l'ancien
  // état : on lui redemande une lecture une fois le sien terminé.
  function redraw() {
    var d = document.querySelector('moonbundle-cart-drawer-block');
    if (!d) return;
    try { if (typeof d.applyCartToDrawer === 'function') d.applyCartToDrawer(CART); } catch (e) {}
    setTimeout(function () {
      try { if (typeof d.loadCart === 'function') d.loadCart(); } catch (e) {}
    }, 700);
  }

  // ── tiroir : « Offerte » dans la langue du client, quantité verrouillée ──
  var LABEL = { fr: 'Offerte', de: 'Gratis', nl: 'Gratis', it: 'In regalo', lt: 'Dovana', el: 'Δώρο', sk: 'Darček' };
  function label() {
    var l = ((window.Shopify && Shopify.locale) || document.documentElement.lang || 'en').slice(0, 2);
    return LABEL[l] || 'Free gift';
  }
  function relabel() {
    var g = (CART.items || []).filter(isGift)[0];
    syncObserver(!!g);
    if (!g) return;
    var drawer = document.querySelector('moonbundle-cart-drawer-block') || document;
    drawer.querySelectorAll('[data-item-key="' + g.key + '"]').forEach(function (node) {
      var item = node.closest('.moonbundle-cart-item') || node.closest('[class*="cart-item-details"]') || node;
      var qc = item.querySelector('.moonbundle-cart-item-quantity-container') || item.querySelector('[class*="quantity-container"]');
      if (qc && qc.style.display !== 'none') qc.style.display = 'none';
    });
    // Le titre de la remise (anglais, seul visible au paiement) : sur la ligne et dans « Économies ».
    if (drawer === document) return;
    var walker = document.createTreeWalker(drawer, NodeFilter.SHOW_TEXT);
    var t;
    while ((t = walker.nextNode())) {
      if (DISCOUNT_TITLE.test(t.nodeValue)) t.nodeValue = t.nodeValue.replace(DISCOUNT_TITLE, label());
    }
  }

  // Moon Bundles redessine son tiroir à chaque changement : on n'observe que si la can y est.
  var obs = new MutationObserver(function () { clearTimeout(obs._t); obs._t = setTimeout(relabel, 60); });
  var obsOn = null;
  function syncObserver(on) {
    var target = on ? (document.querySelector('moonbundle-cart-drawer-block') || document.body) : null;
    if (target === obsOn) return;
    obs.disconnect();
    obsOn = target;
    if (target) obs.observe(target, { childList: true, subtree: true });
  }

  // ── réveil sur écriture panier ──────────────────────────────────────────
  // On n'enveloppe PAS fetch : outdare-pack-integrity.js et Moon Bundles le font déjà, et deux
  // scripts qui se ré-enveloppent l'un l'autre s'empilent jusqu'au plantage. Le navigateur
  // signale chaque requête terminée (PerformanceObserver) : on lit l'URL, on ne touche à rien.
  var WRITE = /\/cart\/(add|change|update|clear)(\.js)?(\?|$)/;

  function watch() {
    if (!window.PerformanceObserver) return;
    try {
      new PerformanceObserver(function (list) {
        if (list.getEntries().some(function (e) { return WRITE.test(e.name); })) kick();
      }).observe({ type: 'resource' });
    } catch (e) {}
  }

  var kickT;
  function kick() {
    clearTimeout(kickT);
    kickT = setTimeout(check, 120);
  }

  function check() {
    if (busy) { kick(); return; }
    return getCart().then(settle).catch(function () {});
  }

  window.addEventListener('moonbundle-cart-updated', kick);
  document.addEventListener('cart:updated', kick);
  document.addEventListener('dp:cart-changed', kick);   // écritures de dp-gift-codes.js et les nôtres, invisibles à l'observateur
  document.addEventListener('visibilitychange', function () { if (!document.hidden) kick(); });

  function start() {
    watch();
    check();
  }
  if (document.readyState !== 'loading') start();
  else document.addEventListener('DOMContentLoaded', start);
})();
